import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import EbrarySubjects from '../components/EbrarySubjects';
import Profile from '../components/Profile';
import Notification from '../components/Notification';
import { FaSearch } from "react-icons/fa";
import Input from '../components/ui/Input';

const AccessCourse = ({ onSearch, initialQuery }) => {
  const [inputValue, setInputValue] = useState(initialQuery || '');
  const [displayname, setDisplayname] = useState(null); // Store the username
  const navigate = useNavigate();
    const [username, setUsername] = useState(null); // Store the username
    const [courseIds, setCourseIds] = useState(null); // Store the username

    // Function to handle the search action
    const handleSearch = () => {
      const query = (inputValue || "").trim();
    
      if (!query) {
        alert("Please enter a search term.");
        return;
      }
  
      const user = JSON.parse(localStorage.getItem("user"));
      const hasCollege = user && user.collegeId;
    
      const targetPath = hasCollege
        ? `/mylibrary?query=${encodeURIComponent(query)}`
        : `/ebrarycollection?query=${encodeURIComponent(query)}`;
    
      navigate(targetPath, { state: { query } });
  
    };

      useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user) {
          setUsername(user.username);  // Set username if user is logged in
          setCourseIds(user.courseIds);
          setDisplayname(user.displayname);
        }
      }, []);


    const handleClear = () => {
      setInputValue('');
    };

  return (
    <div className="bg-gray-100 text-gray-900 flex flex-col min-h-full">

    <div className="flex-1 flex flex-col p-1 bg-gradient-to-br from-gray-50 to-gray-200">
        <div className="flex justify-between items-center relative bg-white p-4 rounded-lg shadow-md">

          <div className="relative w-full max-w-lg">
                          <Input
                            placeholder="Search my library content..."
                            className="pl-10"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') handleSearch();
                            }}
                          />
            <FaSearch className="absolute left-3 top-3 text-gray-500" />
            {inputValue && (
              <button
                onClick={handleClear}
                className="absolute right-3 top-2 text-gray-500 hover:text-gray-700"
                aria-label="Clear search"
              >
                ✕
              </button>
            )}
          </div>

          <div className="flex items-center space-x-4 relative">
            <Notification />
            <Profile />
          </div>
        </div>
        
        
        


      {/* Subjects and Books Section */}
      <EbrarySubjects />

      </div>

    </div>
  );
};


export default AccessCourse;
